import { memo } from 'react';

import { Badge, Flex, Heading, Text } from '@/components/core';
import { TriggerHeader } from '@/components/flow';
import { EmailLogo } from '@/components/logos';
import { toActionId, useGetAction } from '@/hooks/api';
import { toString } from '@/utils';

export type EmailTriggerNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IEmailTriggerNodeContent = ({ agentId, actionId }: EmailTriggerNodeContentProps) => {
  const { data: action } = useGetAction(toActionId(actionId));

  return (
    <>
      <div className="gap-sm flex items-center border-b border-gray-200 pb-2">
        <TriggerHeader agentId={agentId} actionId={actionId}>
          <EmailLogo size="lg" />
          <Heading size="lg">New Email Received</Heading>
        </TriggerHeader>
      </div>

      <Flex className="items-center gap-2 pt-2">
        <Text className="text-nowrap">Email address:</Text>
        <Badge variant="plain" className="grow truncate rounded-sm px-1.5 py-0">
          <Text size="xs" className="truncate font-medium text-gray-600">
            {toString(action?.config?.email)}
          </Text>
        </Badge>
      </Flex>
    </>
  );
};

export const EmailTriggerNodeContent = memo(IEmailTriggerNodeContent) as typeof IEmailTriggerNodeContent;
